import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IrbOptionChainsComponent} from './irb-option-chains.component';
import {OptionChainsTrayComponent} from './option-chains-tray/option-chains-tray.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IrbCommonModule} from '@irb/irb-common/irb-common.module';

import {InputTextModule} from 'primeng/inputtext';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IrbCommonModule,
    InputTextModule
  ],
  declarations: [IrbOptionChainsComponent, OptionChainsTrayComponent],
  exports: [
    IrbOptionChainsComponent,
    OptionChainsTrayComponent
  ]
})
export class IrbOptionChainsModule {
}
